import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { QrScanner } from "@yudiel/react-qr-scanner";
import { QRCode } from "react-qrcode-logo";
import styles from "./styles.module.scss";
import errorMsg from "../../Functions/errorMsg";

const QRCodeScanner = ({ closeScanner, onScan, flashEffect = true, scanDelay = 0 }) => {
  const [flash, setFlash] = useState(false);

  const handleQRCodeScanned = (data) => {
    onScan(data);
    if (flashEffect) {
      setFlash(true);
      setTimeout(() => setFlash(false), 50);
    }
  };

  const handleCameraError = (error) => {
    console.error("QR Scanner Error:", error.message);
    errorMsg("Unable to access the camera. Please check your device settings.");
    closeScanner();
  };

  return (
    <section id={styles.wrapper}>
      {flash && (
        <motion.div
          id={styles.flashOverlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.1 }}
        />
      )}

      <div id={styles.content}>
        <FontAwesomeIcon icon={faXmark} id={styles.exit} onClick={closeScanner} />
        <section>
          <h1>QR Ticket Scan</h1>
          <div id={styles.logoMatch}>
            <QRCode
              id={styles.exampleQR}
              value="EXAMPLE-QR-CODE"
              logoImage="/financehub/exchange-icon.png"
              logoWidth={34}
              logoHeight={34}
              bgColor="transparent"
              qrStyle="dots"
              fgColor="#154734"
              eyeRadius={10}
              eyeColor="#154734"
            />
          </div>
          <QrScanner
            constraints={{ facingMode: "environment" }}
            onDecode={(result) => handleQRCodeScanned(result)}
            onError={handleCameraError}
            scanDelay={scanDelay}
            viewFinder={() => null}
            videoStyle={{ objectFit: 'cover' }}
            containerStyle={{ width: '100%', height: '100%' }}
          />
        </section>
      </div>
    </section>
  );
};

export default QRCodeScanner;